<template>
    
</template>

<script>
    export default {
        name: "simple-weekly-schedule-post"
    }
</script>

<style scoped>

</style>